export enum ReportTypesEnum {
    Detailed = 1,
    Trades,
    Adjustments,
    TotalsByAccount,
    TotalsBySymbol,
    TotalsByDate,
    OpenPositions,
    SummaryByDate,
    FeesByDestination,
    GroupSummaryByDate,
    TotalsByGroup,
    GroupTotalsBySymbol,
    GroupFeesByDestination,
    GroupOpenPositions,
    GroupAdjustments,
}
